export default "__VITE_ASSET__B69Hr$cg__"